// extracted by mini-css-extract-plugin
export default {"semiBoldText":"styles_semiBoldText__m79hF"};